/**
 * PlannedBudgetItemService
 * Service for PlannedBudgetItem entity operations
 * Route: api/planned-budget-items
 * Controller: PlannedBudgetItemController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PlannedBudgetItemService
 * Handles planned budget item CRUD operations
 * Maps to /api/planned-budget-items endpoint
 */
export class PlannedBudgetItemService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PlannedBudgetItemService.DEFAULT_SERVICE_PATH,
            basePath: PlannedBudgetItemService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
PlannedBudgetItemService.DEFAULT_SERVICE_PATH = 'projects';
PlannedBudgetItemService.BASE_PATH = 'api/planned-budget-items';
//# sourceMappingURL=PlannedBudgetItemService.js.map